import { render } from "./OpeningHours.vue?vue&type=template&id=082b1ca0"
import script from "./OpeningHours.vue?vue&type=script&lang=js"
export * from "./OpeningHours.vue?vue&type=script&lang=js"

import "./OpeningHours.vue?vue&type=style&index=0&id=082b1ca0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__